import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
} from "react";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import {API} from "../../helpers/constants";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { showPopup } from '../../../src/components/globalPopup/globalPopupService';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../loanApplication/locales/namespaces";



const initialState = {
  data: [],
};

const WizardContext = createContext(initialState);

const WizardProvider = ({ children }) => {
  
  const { t } = useTranslation(LOANS_APPLICATION)

  const getStructureData = useCallback(({ loanId, onSuccess, onError}) => {
    return axios
      .post(`${API}/structure`, { LoanId: loanId })
      .then((response) => {
        if (typeof onSuccess === "function") onSuccess(response.data);
      })
      .catch((error) => {
        enqueueSnackbar(
          handleAxiosErrors(error, error.response.data.message),
          { variant: "error" }
        );
      });
  }, []);

  const copyStructure = useCallback(({ loanId, selectedLoanId, email, key, onSuccess, onError}) => {
    // only in fast-login (unauthenticated) flow send email/key; otherwise keep the original call as-is
    const payload = email && key
      ? { SelectedLoanId: selectedLoanId, email: email, key: key }
      : { LoanId: loanId, SelectedLoanId: selectedLoanId };
    return axios
      .post(`${API}/copy-structure`, payload)
      .then((response) => {
        if (typeof onSuccess === "function") onSuccess(response.data);
      })
      .catch((error) => {
        enqueueSnackbar(
          handleAxiosErrors(error, error.response.data.message),
          { variant: "error" }
        );
      });
  }, []);

  const submitForm = useCallback(({ loanId, data, isFinal, email, key, onSuccess, onError }) => {
    // email/key are only sent in the fast-login (unauthenticated) flow
    const payload = {
      isFinal: isFinal ? "1" : null,
      data: data
    };
    if (loanId !== undefined && loanId !== null) payload.LoanId = loanId.toString();
    if (email) payload.email = email;
    if (key) payload.key = key;
    return axios
      .post(`${API}/save-app`, payload)
      .then((response) => {
        showPopup({
          title: '',
          message: isFinal ? t("Your application has been submitted successfully and is under review") : t("Your application has been temporarily saved."),
          onConfirm: () => {
            if (typeof onSuccess === "function") onSuccess(response.data);
          }
        })
        
      })
      .catch((error) => {
        if (typeof onError === "function") onError(error, error.response.data.message)
        showPopup({
          title: '',
          message: t("Not all required fields have been filled in or a field contains an invalid value"),
          onConfirm: () => {
      
          }
        })
      });
  }, []);
  
  const value = useMemo(() => ({
    getStructureData,
    copyStructure,
    submitForm,
  }), [
    getStructureData,
    copyStructure,
    submitForm,
  ]);

  return (
    <WizardContext.Provider value={value}>
      {children}
    </WizardContext.Provider>
  )
}

const useWizard = () => {
  const context = useContext(WizardContext);

  if (context === undefined) {
    throw new Error("useWizard must be used within WizardProvider");
  }

  return context;
}

export { WizardContext, WizardProvider, useWizard };
